"use strict";
exports.__esModule = true;
exports.chart_color_gold_400 = {
  "name": "--pf-v5-chart-color-gold-400",
  "value": "#f0ab00",
  "var": "var(--pf-v5-chart-color-gold-400, #f0ab00)"
};
exports["default"] = exports.chart_color_gold_400;